import * as types from '../mutations'
import codesService from '@/services/codes'
import Vue from 'vue'

const state = {
  templates: [],
  templatesLoading: false
}

const getters = {
  qrTemplates: state => state.templates
}

const actions = {

  async loadQrTemplates ({ commit, state }) {
    if (state.templates.length || state.templatesLoading) {
      return
    }
    commit(types.SET_QR_TEMPLATES_LOADING, true)
    try {
      const templates = await codesService.loadQrTemplates()
      commit(types.SET_QR_TEMPLATES_LIST, templates)
    } finally {
      commit(types.SET_QR_TEMPLATES_LOADING, false)
    }
  },

  async createQrTemplate ({ commit }, template) {
    const res = await codesService.createQrTemplate(template)
    commit(types.ADD_QR_TEMPLATE, res)
  },

  async updateQrTemplate ({ commit }, { id, template }) {
    const res = await codesService.updateQrTemplate(id, template)
    commit(types.UPDATE_QR_TEMPLATE, res)
  },

  async deleteQrTemplate ({ commit }, { id }) {
    await codesService.deleteQrTemplate(id)
    commit(types.DELETE_QR_TEMPLATE, { id: id })
  }
}

const mutations = {

  [types.SET_QR_TEMPLATES_LIST] (state, templates) {
    state.templates = templates
  },

  [types.SET_QR_TEMPLATES_LOADING] (state, loading) {
    state.templatesLoading = loading
  },

  [types.ADD_QR_TEMPLATE] (state, template) {
    state.templates.unshift(template)
  },

  [types.UPDATE_QR_TEMPLATE] (state, template) {
    const index = state.templates.findIndex((t) => t.id === template.id)
    if (~index) {
      Vue.set(state.templates, index, { ...state.templates[index], ...template })
    }
  },

  [types.DELETE_QR_TEMPLATE] (state, { id }) {
    const index = state.templates.findIndex((t) => t.id === id)
    if (~index) {
      state.templates.splice(index, 1)
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
